import React from 'react';
export function TypesOfEDMSection() {
  return <section data-id="element-4148">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4149">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4150">
          Types of EDM Machine
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-4151">
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-4152">
          {/* Wire EDM */}
          <div className="space-y-6 text-center" data-id="element-4153">
            <h3 className="text-2xl font-bold text-orange" data-id="element-4154">Wire EDM</h3>
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Wire/AgieCharmilles%20Wire%20EDM%20Taper.jpg" alt="AgieCharmilles Wire EDM Taper" className="block mx-auto h-64 object-contain rounded-lg" data-id="element-4155" />
            <ul className="text-left text-gray-700 text-lg space-y-3 list-disc list-inside max-w-sm mx-auto" data-id="element-4156">
              <li data-id="element-4157">Water based dielectric (not the rule)</li>
              <li data-id="element-4158">Through Cavity produced</li>
              <li data-id="element-4159">
                Electrode typically is either brass or copper with either a
                coating or non-coated
              </li>
            </ul>
          </div>

          {/* Sinker EDM */}
          <div className="space-y-6 text-center" data-id="element-4160">
            <h3 className="text-2xl font-bold text-orange" data-id="element-4161">
              Die-Sinking (Sinker) EDM
            </h3>
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/EDM%20Images/Sinker%20EDM.jpg" alt="Sinker EDM" className="block mx-auto h-64 object-contain rounded-lg" data-id="element-4162" />
            <ul className="text-left text-gray-700 text-lg space-y-3 list-disc list-inside max-w-sm mx-auto" data-id="element-4163">
              <li data-id="element-4164">Oil based dielectric</li>
              <li data-id="element-4165">Through cavity or blind cavity produced</li>
              <li data-id="element-4166">Electrode typically is graphite or brass</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}